function fetchSystemMessages(data, apiClient, priority) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/systemMessages`;
  return apiClient.get(route, { query: { priority } });
}

export default {
  fetchSystemMessages
};
